module.exports = __webpack_public_path__ + "img/PT.9647512.svg";